$(document).ready(function () {
    var $navbar = $('.header-section');
    var $toolbar = $('#epb_container');
    var lastScrollTop = 0;

    $(window).on('scroll', function () {
      var scrollTop = $(this).scrollTop();
      if (scrollTop <= 50) {
        $navbar.removeClass('active bgcolor');
      }
      // Scrolling down
      else if (scrollTop > lastScrollTop) {
        $navbar.addClass('active bgcolor');
        $toolbar.addClass('active bgcolor');
      }
      // Scrolling up
      else if (scrollTop < lastScrollTop) {
        $navbar.removeClass('active');
        $toolbar.removeClass('active');
      }
      lastScrollTop = scrollTop;
    });
});